/**
 * Types of recent search items
 */
export const RECENT_ITEM_TYPE = {
  USER: 'user',
  TAG: 'tag',
  QUERY: 'query',
} as const;
